import React from "react";
import clsx from "clsx";

import { OverflowTooltip } from "components";
import { getFullName } from "helpers";
import { defineAgentOfficePackageClassName } from "mappers";
import { Application, TableCellProp } from "types";

const agentOfficeAgentNameColumn = () => ({
	Header: "Agent Office Agent Name",
	accessor: "applicationAgentName",
	disableSortBy: true,
	Cell: ({ row: { original } }: TableCellProp<Application>) => {
		const agentOfficeClassName = defineAgentOfficePackageClassName(
			original.agent_office?.package,
		);
		const agentName = getFullName(original?.agent);

		const fullName = `${original?.agent_office?.name || ""} ${agentName}`;

		return (
			<span
				className={clsx(
					"cut-text-laptop",
					"agent-office-package",
					agentOfficeClassName,
				)}
			>
				<OverflowTooltip onlyOnLaptop title={fullName}>
					{fullName}
				</OverflowTooltip>
			</span>
		);
	},
});

export default agentOfficeAgentNameColumn;
